module.exports = __webpack_public_path__ + "static/img/bg-fr.32e250b9.webp";